import type { IconSvgObject } from './types';

const CircleArrowDownDoubleIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 12.9154C15 12.9154 12.7905 15.5 12 15.5C11.2094 15.5 9 12.9154 9 12.9154M15 8.50002C15 8.50002 12.7905 11.0846 12 11.0846C11.2094 11.0846 9 8.5 9 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleArrowDownDoubleIcon;
